import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { WarehouseMovementDTO } from "../../features/warehouse/models/entities";
import { BehaviorSubject, Observable } from "rxjs";
import { DynacrudApi } from "../models/dynacrud";
import { DynaCrudRequest } from "../../store/shared/shared.reducers";


// Defined here (not in TableEditRowsComponent) so consumers of this service
// can import it without dragging the whole table component in - which created
// a circular module-load: draft-service -> set-insert.service -> table-edit-rows
// -> draft-service. Surfacing as runtime NG0301/NG0303 errors once the draft
// service got injected into widely-used components.
export enum TypeSaveInsert {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE'
}


interface DataJson<key> {
  data: key;
}

export interface Loads {
  filter: DynaCrudRequest,
  items: any[] | Object[] | Object,
  all?: boolean
}

export interface DraftSummaryResponse {
  key: string;
  savedAt: string | null;
  value: Loads;
}

@Injectable({
  providedIn: 'root'
})
export class SetInsertService {

  constructor(private http: HttpClient) { }

  public saveMovements(WhMovement: WarehouseMovementDTO, type: TypeSaveInsert, sessionId?: number): Observable<DynacrudApi<WarehouseMovementDTO>> {
    if (sessionId) {
      return this.http.post<DynacrudApi<WarehouseMovementDTO>>(`${environment.apiUrl}/v2/sessions/${sessionId}/${type == TypeSaveInsert.SINGLE ? 'movements' : 'movementsbulk'}`, WhMovement);
    } else {
      return this.http.post<DynacrudApi<WarehouseMovementDTO>>(`${environment.apiUrl}/v2/sessions/${type == TypeSaveInsert.SINGLE ? 'movements' : 'movementsbulk'}`, WhMovement);
    }

  }

  public youCanClickButtonReload = new BehaviorSubject(true);

  public youCanClickButton() {

    return this.youCanClickButtonReload.asObservable();

  }


  private subjectLoads = new BehaviorSubject<any[] | undefined>(undefined);
  public readonly readLoads = this.subjectLoads.asObservable();

  saveObjectKey(key: string, loads: Loads, keep: boolean = false) {
    return this.http.post<DataJson<Loads>>(
      `${environment.apiUrl}/v2/userDrafts/${key}?keep=${keep}`, loads);
  }

  listDrafts(prefix: string) {
    return this.http.get<DataJson<DraftSummaryResponse[]>>(
      `${environment.apiUrl}/v2/userDrafts?prefix=${prefix}`);
  }

  getLoads(key: string) {
    return this.http.get<DataJson<Loads>>(`${environment.apiUrl}/v2/userDrafts/${key}`);
  }


  getExisteLoads(key: string) {
    return this.http.get<DataJson<Loads>>(`${environment.apiUrl}/v2/userDrafts/exists/${key}`);
  }

  deleteLoads(key: string) {
    return this.http.delete<DataJson<Loads>>(`${environment.apiUrl}/v2/userDrafts/${key}`);
  }

  setLoadsAsync(values: any[]) {
    this.subjectLoads.next(values);
  }


}
